import { createSlice, PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { RequestConfig } from '../../services/Main/types.Component';

export interface BatchActionDialogState {
  requestConfig: RequestConfig;
}

export type BatchActionDialogStoreState = BatchActionDialogState | null;

const open: CaseReducer<
  BatchActionDialogStoreState,
  PayloadAction<BatchActionDialogState>
> = (_state, action) => action.payload;

const close: CaseReducer<BatchActionDialogStoreState> = () => null;

export const { reducer, actions } = createSlice({
  name: 'batchActionDialog',
  initialState: null as BatchActionDialogStoreState,
  reducers: {
    open,
    close,
  },
});

export default reducer;
